export const headersSelo = {
    indicadores_ativos: [
        { text: 'Pilar', value: 'nome' },
        { text: 'Número', value: 'numero' },
        { text: 'Pontos', value: 'pontos' },
        { text: 'Critério', value: 'texto' },
        { text: 'Evidencia', value: 'evidencia' },

    ],
    rejeicao: [
        { text: 'Parceiro', value: 'municipio' },
        { text: 'Pilar', value: 'eixo' },
        { text: 'Respondidas', value: 'respondidas' },
        { text: 'Evidenciadas', value: 'evidenciadas' },
        { text: 'Aguardando Análise', value: 'aguardandoAnalise' },
        { text: 'Aprovadas', value: 'aprovadas' },
        { text: 'Perguntas', value: 'perguntas' },
        { text: 'Rejeitadas', value: 'rejeitadas' }
    ],
    evidencias: [
        { text: 'Parceiro', value: 'municipio', align: 'start' },
        { text: 'Pilar', value: 'eixo' },
        { text: 'Questões não evidenciadas', value: 'semEvidencias' }
    ],
    evidencias: [
        { text: 'Parceiro', value: 'municipio', align: 'start' },
        { text: 'Pilar', value: 'eixo' },
        { text: 'Questões não evidenciadas', value: 'semEvidencias' }
    ],
    situacao_detalhada_envio_evidencia: [
        { text: 'Regional', value: 'nomeRegiao', align: 'start' },
        { text: 'Sala', value: 'municipioNome', align: 'start' },
        { text: 'Pilar', value: 'nomeTema', align: 'start' },
        { text: 'Critério', value: 'texto', align: 'start' },
        { text: 'Arquivos Enviados', value: 'arquivosEnviados', align: 'start' },
        { text: 'Arquivos em Análise', value: 'arquivosAnalise', align: 'start' },
        { text: 'Arquivos Aprovados', value: 'arquivosAprovados', align: 'start' },
        { text: 'Arquivos Rejeitados', value: 'arquivosREjeitados', align: 'start' },
        { text: 'Pontos Possíveis', value: 'pontosPossiveis', align: 'start' },
        { text: 'Pontos Obtidos', value: 'pontosObtidos', align: 'start' },
    ]

}
